import { type TSocialMedia } from '@shared/ui'
import { useMemo } from 'react'

import useData from './query'

export default () => {
  const {
    site: {
      siteMetadata: {
        externalUrls: { discord: discordUrl },
      },
    },
  } = useData()

  const links = useMemo<{ ariaLabel: TSocialMedia; to: string }[]>(
    () => [{ ariaLabel: 'Discord', to: discordUrl }],
    [discordUrl]
  )

  return links
}
